export default "__VITE_ASSET__BOvEBjr7__"